import {
	FileText,
	BookOpen,
	Book,
	Library,
	NotebookPen,
	ClipboardList,
	ListChecks,
	Calendar,
	CalendarDays,
	Map,
	MapPin,
	Flag,
	Target,
	Rocket,
	Lightbulb,
	Sparkles,
	Megaphone,
	MessageSquare,
	Users,
	User,
	GraduationCap,
	HelpCircle,
	Info,
	Shield,
	Lock,
	Key,
	Settings,
	Wrench,
	Code,
	Terminal,
	Bug,
	Database,
	Globe,
	Link,
	Image,
	ChartNoAxesCombined,
	Heart,
	Star,
	Zap,
	Coffee,
	Utensils
} from "lucide-react"
import type { ComponentProps } from "react"

export const kbIcons = {
	FileText,
	BookOpen,
	Book,
	Library,
	NotebookPen,
	ClipboardList,
	ListChecks,
	Calendar,
	CalendarDays,
	Map,
	MapPin,
	Flag,
	Target,
	Rocket,
	Lightbulb,
	Sparkles,
	Megaphone,
	MessageSquare,
	Users,
	User,
	GraduationCap,
	HelpCircle,
	Info,
	Shield,
	Lock,
	Key,
	Settings,
	Wrench,
	Code,
	Terminal,
	Bug,
	Database,
	Globe,
	Link,
	Image,
	ChartNoAxesCombined,
	Heart,
	Star,
	Zap,
	Coffee,
	Utensils
}

export function KBIcon({
	name,
	...props
}: ComponentProps<typeof FileText> & { name?: string | null }) {
	const Icon =
		Object.entries(kbIcons).find(([key]) => key === name)?.[1] ?? FileText
	return <Icon {...props} />
}
